import { getSettings } from '../lib/data.js';
import { SOUND_CHANNELS } from '../lib/content-defaults.js';
import { esc } from '../lib/utils.js';

export async function renderPoradatele(view) {
    const settings = await getSettings();
    const name = settings.contact_name || '';
    const email = settings.contact_email || '';
    const phone = settings.contact_phone || '';
    const rider = settings.rider_text || '';
    const tech = settings.tech_requirements || '';
    const soundConnection = settings.sound_connection || '';
    const soundNotes = settings.sound_notes || '';
    const fb = settings.facebook_url || '';

    view.innerHTML = `
        <section class="section narrow">
            <h1 class="page-title">Pro pořadatele</h1>
        </section>

        <section class="section narrow">
            <div class="contact-card">
                <h2 class="section-title">Kontakt</h2>
                <ul class="contact-list">
                    ${name ? `<li><span class="co-label">Kontaktní osoba</span>
                        <span>${esc(name)}</span></li>` : ''}
                    ${phone ? `<li><span class="co-label">Telefon</span>
                        <a href="tel:${esc(phone.replace(/\s/g, ''))}">${esc(phone)}</a></li>` : ''}
                    ${email ? `<li><span class="co-label">E-mail</span>
                        <a href="mailto:${esc(email)}">${esc(email)}</a></li>` : ''}
                    ${fb ? `<li><span class="co-label">Facebook</span>
                        <a href="${esc(fb)}" target="_blank" rel="noopener">napište nám zprávu</a></li>` : ''}
                </ul>
                ${(!name && !email && !phone && !fb)
                    ? '<p class="muted">Kontaktní údaje se brzy doplní.</p>' : ''}
            </div>
        </section>

        <section class="section narrow">
            <h2 class="section-title">Ozvučení</h2>
            ${rider
                ? `<div class="rider">${paragraphs(rider)}</div>`
                : '<p class="muted">Technický rider vám rádi pošleme na vyžádání.</p>'}
        </section>

        <section class="section narrow">
            <h2 class="section-title">Technické požadavky</h2>
            ${tech
                ? `<ul class="req-list">${tech.split('\n').filter((t) => t.trim())
                    .map((t) => `<li>${esc(t.trim())}</li>`).join('')}</ul>`
                : '<p class="muted">Požadavky vám rádi sdělíme na vyžádání.</p>'}
        </section>

        ${soundConnection ? `
        <section class="section narrow">
            <h2 class="section-title">Napojení na zvuk při vícekapelových akcích</h2>
            <div class="rider">${paragraphs(soundConnection)}</div>
            <div class="table-wrap">
                <table class="channel-table">
                    <thead>
                        <tr><th>#</th><th>Signál</th><th>Výstup</th><th>Výstupní konektor na našem splitu</th></tr>
                    </thead>
                    <tbody>
                        ${SOUND_CHANNELS.map((c) => `
                            <tr>
                                <td>${esc(c.ch)}</td>
                                <td>${c.signal ? esc(c.signal) : '<span class="ch-empty">—</span>'}</td>
                                <td>${esc(c.output)}</td>
                                <td>${esc(c.connector)}</td>
                            </tr>`).join('')}
                    </tbody>
                </table>
            </div>
            ${soundNotes ? `<div class="rider" style="margin-top:20px;">${paragraphs(soundNotes)}</div>` : ''}
        </section>` : ''}
    `;
}

function paragraphs(text) {
    return (text || '').split(/\n\s*\n/).map((p) =>
        `<p>${esc(p.trim()).replace(/\n/g, '<br>')}</p>`
    ).join('');
}
